import { useState, useEffect } from "react";
import { Card, Table, Form } from "react-bootstrap";
import authenticatedFetch from "./fetch"


const AvailableReminderPreference = ({ id, name, isActive, onChange, canEdit }) => {
  const [localIsActive, setLocalIsActive] = useState(isActive);

  const handleIsActiveChanged = (e) => {
    setLocalIsActive(e.target.checked);
    onChange(id, e.target.checked);
  }

  return (
    <tr>
        <td>{name}</td>
        <td><Form.Check checked={localIsActive} disabled={!canEdit} onChange={(e) => {handleIsActiveChanged(e)}} /></td>
    </tr>
  );
}

const ReminderPreferenceAssignment = ({entityType, id, onReminderPreferenceChanged, canEdit, refresh}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    authenticatedFetch({
      path: id && id > 0 ? "admin/" + entityType + "/reminderpreferences/" + id : "admin/" + entityType + "/reminderpreferences/",
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);

        for (var i = 0; i < result.length; i++)
        {
          onReminderPreferenceChanged(result[i].id, result[i].isActive);
        }
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [id, refresh])

  var preferenceList;

  if (error)
  {
    preferenceList = <tr><td colSpan="4">Error... please try again...</td></tr>;
  }
  else if (!isLoaded)
  {
    preferenceList = <tr><td colSpan="4">Loading...</td></tr>;
  }
  else if (!data || data.length === 0)
  {
    preferenceList = <tr><td colSpan="4">No hubs found...</td></tr>;
  }
  else
  {
    preferenceList = data.map((preference) => {
      return (
        <AvailableReminderPreference key={preference.id} id={preference.id} name={preference.name} isActive={preference.isActive} onChange={onReminderPreferenceChanged} canEdit={canEdit}/>
      )
    }, this);
  }

  return (
    <Card>
      <Card.Header style={{marginBottom: '-15px'}}>
        <Card.Title>
        Preferences & Settings
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table striped hover>
          <thead>
            <tr>
              <td>Name</td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            {preferenceList}
          </tbody>
        </Table>
      </Card.Body>
  </Card>
  )
}

export default ReminderPreferenceAssignment;